import { pick, cloneDeep } from 'lodash-es'

class Field {
  constructor(defaultValue, dbColumn, verboseName) {
    this.dbColumn = dbColumn
    this.defaultValue = defaultValue
    this.verboseName = verboseName
  }
}

/**
 * 继承此类的子类, 普通类型的字段直接使用字段声明语法声明到类上, 然后在构造函数中调用 setValues 赋值
 * 复杂类型的字段在子类构造函数中自行处理
 *
 * 1. 有新增的需要传到接口的字段要声明为类属性, 如下
 * class Foo {
 *   a = 1
 *   b = 2
 * }
 * 2. 第一点的特殊情况就是这个字段的值是需要经过计算 or 转换才能得到的, 可以不声明, 在 getBackendData 里再计算赋值就行
 *
 * @export
 * @class BaseModel
 */
export class BaseModel {
  id
  insertTime
  modifyTime

  constructor() {
    // _properties 用来保存所有实例属性
    Object.defineProperty(this, '_properties', {
      value: [],
      enumerable: false,
      configurable: false
    })
  }

  _getProperties() {
    return cloneDeep(this._properties)
  }

  /**
   * 收集子类的所有 实例属性 字段
   */
  _collectProperties() {
    const modelKeys = Object.keys(this).filter(key => typeof this[key] !== 'function')
    this._properties.push(...modelKeys)
  }

  /**
   * 实例化 model 时，简单类型的字段直接赋值
   *
   * @param {*} [obj={}]
   * @memberof BaseModel
   */
  _setValues(obj = {}) {
    for (const key of this._properties) {
      this[key] = obj[key] ?? this[key]
    }
  }

  /**
   * 子类实现自己的初始化赋值方法
   * 接口返回的数据和前端需要的不一致, 在这里做转换
   *
   * @abstract
   * @param {any} initObj
   */
  init(initObj) {}

  /**
   * 发给后台的数据只需要模型定义的, 前端可能会因为使用需要在对象中加一些状态变量,这些不用发给后台
   *
   * @returns {any} 深拷贝的实例对象, 只包含在类中声明了的字段
   */
  getBackendData() {
    return cloneDeep(pick(this, this._properties))
  }
}

export default {
  Field,
  BaseModel
}
